import aeroLogo from '@assets/images/NavBar/aerocomp.png';
import cybernestLogo from '@assets/images/Hero/cybernest.png';
import flowLogo from '@assets/images/Hero/flow.png';

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0B] text-white">
      {/* === Main Upper Section === */}
      <div className="mx-auto max-w-7xl border-b border-gray-700 px-6 py-12 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 gap-8 sm:gap-12 md:grid-cols-3 lg:gap-40">
          {/* === Left: Logo & Tagline === */}
          <div className="space-y-3 text-center md:text-left">
            <div className="flex items-center justify-center gap-3 md:justify-start">
              <img
                src={aeroLogo}
                alt="AeroComp Logo"
                className="h-10 w-auto object-contain"
              />
              <h3 className="text-xl font-bold text-white">AeroComp</h3>
            </div>
            <p className="mx-auto max-w-md text-lg font-medium leading-6 text-white md:mx-0">
              Advance Protection,
              <br />
              Engineered to Endure.
            </p>
          </div>

          {/* === Middle: Contact Info === */}
          <div className="space-y-3 text-center md:text-left">
            <h4 className="font-semibold text-[#FFBD59]">Contact us</h4>
            <div className="space-y-2 tracking-tighter text-gray-300">
              <p className="text-base">
                <span className="font-semibold text-white">Contact No:</span>{' '}
                +63 968-899-9421
              </p>
              <p className="text-base">
                <span className="text-base font-semibold text-white">
                  Email:
                </span>{' '}
                aerocompproject@gmail.com
              </p>
              <p className="mx-auto max-w-md text-base leading-relaxed md:mx-0">
                <span className="font-semibold text-white">Location:</span>{' '}
                UPSCALE, Ground Floor, Juinio Hall, National Engineering Center,
                Osmeña Avenue, University of the Philippines, Diliman, Quezon
                City
              </p>
            </div>
          </div>

          {/* === Right: Social Links === */}
          <div className="space-y-4 text-center md:text-left">
            <h4 className="font-semibold text-[#FFBD59]">Social Links</h4>
            <ul className="flex flex-col items-center gap-6 text-base font-medium text-white md:items-start">
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noreferrer"
                  className="transition hover:text-[#FFBD59]"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noreferrer"
                  className="transition hover:text-[#FFBD59]"
                >
                  YouTube
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                  className="transition hover:text-[#FFBD59]"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* === Bottom Bar === */}
      <div className="flex flex-col items-center justify-between gap-3 bg-[#EDEDED] px-6 py-3 text-xs text-gray-700 md:flex-row md:px-12 lg:px-24">
        <p className="text-center md:text-left">
          ©AeroComp All Rights Reserved.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 text-xs md:justify-end">
          <span className="font-medium text-gray-700">Powered By:</span>
          <img
            src={cybernestLogo}
            alt="Cybernest Solutions"
            className="h-8 w-auto object-contain md:h-10"
          />
          <img
            src={flowLogo}
            alt="Flow"
            className="h-3.5 w-auto object-contain md:h-4"
          />
        </div>
      </div>
    </footer>
  );
}
